import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/translatorDefaultPhoto.png'
import _imports_1 from '@/assets/images/access-time.svg'
import _imports_2 from '@/assets/images/pointer.svg'
import _imports_3 from '@/assets/images/close.svg'
import _imports_4 from '@/assets/images/phone.svg'
import _imports_5 from '@/assets/images/mail-outline.svg'


const _withScopeId = n => (_pushScopeId("data-v-69ef66a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "translation-card-triangle --light"
}
const _hoisted_3 = {
  key: 1,
  class: "translation-card-triangle --dark"
}
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = ["alt"]
const _hoisted_6 = { class: "flex translator-card-row md:items-center flex-wrap" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = ["alt"]
const _hoisted_9 = { class: "flex items-start self-baseline flex-wrap flex-col md:flex-row" }
const _hoisted_10 = {
  key: 0,
  class: "pr-5 font-bold text-[1rem] md:text-2xl pb-3 md:pb-0 w-auto break-words"
}
const _hoisted_11 = {
  key: 1,
  class: "pr-5 font-bold text-[1rem] md:text-lg pb-3 md:pb-0 w-auto break-words"
}
const _hoisted_12 = { class: "flex flex-wrap" }
const _hoisted_13 = ["aria-label"]
const _hoisted_14 = {
  key: 0,
  class: "pt-1 pb-1 pl-2 pr-2 bg-black-100 text-white rounded-lg"
}
const _hoisted_15 = { class: "font-bold pr-4" }
const _hoisted_16 = {
  key: 0,
  class: "flex items-center flex-wrap"
}
const _hoisted_17 = {
  key: 0,
  class: "pr-4 text-light-secondary"
}
const _hoisted_18 = {
  key: 1,
  class: "flex text-light-secondary"
}
const _hoisted_19 = ["alt"]
const _hoisted_20 = ["aria-label"]
const _hoisted_21 = { class: "hidden md:inline" }
const _hoisted_22 = { class: "flex text-light-secondary items-center text-sm" }
const _hoisted_23 = ["aria-label", "alt"]
const _hoisted_24 = ["aria-label"]
const _hoisted_25 = {
  key: 0,
  class: "flex flex-col-reverse md:flex-row"
}
const _hoisted_26 = { class: "flex flex-wrap translator-card-row" }
const _hoisted_27 = ["alt"]
const _hoisted_28 = { class: "modal__content" }
const _hoisted_29 = { class: "flex flex-wrap text-sm pb-0 md:pb-[1.125rem] lg:pb-6" }
const _hoisted_30 = ["href"]
const _hoisted_31 = ["aria-label", "alt"]
const _hoisted_32 = { class: "break-words break-word-custom" }
const _hoisted_33 = ["href"]
const _hoisted_34 = ["aria-label", "alt"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "break-words break-word-custom" }, "E-mail", -1))

import {inject, Ref, ref, withDefaults} from 'vue'
import StarsCounter from '@/components/atoms/StarsCounter.vue'
import ButtonPrimary from '@/components/atoms/ButtonPrimary.vue';
import router, { getRouteName } from "@/router";
import {VueFinalModal} from "vue-final-modal";
import TranslatorPage from "@/views/TranslatorPage.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TranslatorCard',
  props: {
    name: null,
    nameSlug: null,
    tpNumberSlug: null,
    stars: null,
    count: null,
    languages: null,
    address: null,
    vip: { type: Boolean, default: false },
    displayLangsDetails: { type: Boolean, default: false },
    askMoreButton: { type: Boolean, default: false },
    askForOffer: { type: Boolean, default: false },
    addressButton: { type: Boolean, default: false },
    alternativeLook: { type: Boolean, default: false },
    email: { default: '' },
    phone: { default: '' },
    profileImgUrl: null,
    translatorCardId: null,
    nameHeader: { default: 'h2' }
  },
  setup(__props: any) {

const props = __props as { name: string, nameSlug: string, tpNumberSlug: string, stars: number, count: number, languages: object[], address: string, vip: boolean, displayLangsDetails: boolean, askMoreButton: boolean, askForOffer: boolean, addressButton: boolean, alternativeLook: boolean, email: string, phone: string, profileImgUrl?: string, translatorCardId?: string, nameHeader: string }



const openModal = ref(false);
const showTranslatorProfileModal = ref(false);
const mainRoute: {value?: {href?: string}} = ref({});
function closingTranslatorProfileModal() {
    openModal.value = false;
    history.pushState(
        {},
        '',
        `${mainRoute.value?.href}`
    );
}

function openedTranslatorProfileModal() {
    // const query = router.currentRoute.value.query;
    let newRoute = router.resolve({
        name: getRouteName('translatorPage'),
        params: { nameSlug: props.nameSlug, tpNumberSlug: props.tpNumberSlug },
    });
    openModal.value = true;
    mainRoute.value = router.currentRoute.value;
    history.pushState(
        {},
        '',
        `${newRoute.href}`
    );
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    id: __props.translatorCardId,
    tabindex: "0",
    class: _normalizeClass(["translator-card md:flex bg-white", { '--alternativeLook': __props.alternativeLook }])
  }, [
    (!__props.alternativeLook)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    (!__props.alternativeLook)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3))
      : _createCommentVNode("", true),
    (__props.profileImgUrl)
      ? (_openBlock(), _createElementBlock("img", {
          key: 2,
          src: __props.profileImgUrl,
          alt: _ctx.$t('translatorPage.translatorImageAlt'),
          class: "translator-card-image md:block hidden"
        }, null, 8, _hoisted_4))
      : (_openBlock(), _createElementBlock("img", {
          key: 3,
          src: _imports_0,
          alt: _ctx.$t('translatorPage.translatorImageAlt'),
          class: "translator-card-image md:block hidden"
        }, null, 8, _hoisted_5)),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_6, [
        (__props.profileImgUrl)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: __props.profileImgUrl,
              alt: _ctx.$t('translatorPage.translatorImageAlt'),
              class: "translator-card-image md:hidden block"
            }, null, 8, _hoisted_7))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: _imports_0,
              alt: _ctx.$t('translatorPage.translatorImageAlt'),
              class: "translator-card-image md:hidden block"
            }, null, 8, _hoisted_8)),
        _createElementVNode("div", _hoisted_9, [
          (__props.nameHeader === 'h2')
            ? (_openBlock(), _createElementBlock("h2", _hoisted_10, _toDisplayString(__props.name), 1))
            : _createCommentVNode("", true),
          (__props.nameHeader === 'h3')
            ? (_openBlock(), _createElementBlock("h3", _hoisted_11, _toDisplayString(__props.name), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_12, [
            _withDirectives(_createVNode(StarsCounter, {
              stars: __props.stars,
              class: "pr-2"
            }, null, 8, ["stars"]), [
              [_vShow, __props.stars]
            ]),
            _withDirectives(_createElementVNode("span", {
              "aria-label": _ctx.$t('translatorCard.votesNumber') + ' ' + __props.count,
              class: "pr-3"
            }, "(" + _toDisplayString(__props.count) + ")", 9, _hoisted_13), [
              [_vShow, __props.count]
            ]),
            (__props.vip)
              ? (_openBlock(), _createElementBlock("p", _hoisted_14, "VIP"))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["translator-card-row flex-wrap flex-col sm:flex-row", { 'flex': !__props.alternativeLook }])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.languages, (language) => {
          return (_openBlock(), _createElementBlock("div", {
            key: language,
            class: _normalizeClass(["flex flex-col sm:flex-row", { 'translator-card-row': __props.alternativeLook,  'mr-7': !__props.alternativeLook }])
          }, [
            _createElementVNode("span", _hoisted_15, _toDisplayString(language.name), 1),
            ((__props.displayLangsDetails && language.dateFrom) || (__props.displayLangsDetails && language?.deadline > 0 && language?.deadlineValue))
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  (__props.displayLangsDetails && language.dateFrom)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.$t('translatorCard.dateFrom')) + " " + _toDisplayString(language.dateFrom), 1))
                    : _createCommentVNode("", true),
                  (__props.displayLangsDetails && language?.deadline > 0 && language?.deadlineValue)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("img", {
                          src: _imports_1,
                          alt: _ctx.$t('translatorCard.clockIconAlt'),
                          class: "pr-2 self-baseline"
                        }, null, 8, _hoisted_19),
                        _createElementVNode("span", {
                          "aria-label": _ctx.$t('translatorCard.deadlineAriaLabel') + language?.deadlineValue
                        }, [
                          _createElementVNode("template", _hoisted_21, [
                            _createTextVNode(_toDisplayString(_ctx.$t('translatorCard.deadline')) + ":", 1)
                          ]),
                          _createTextVNode(" " + _toDisplayString(language?.deadlineValue), 1)
                        ], 8, _hoisted_20)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ], 2))
        }), 128)),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("img", {
            src: _imports_2,
            class: "translation-card-pointer",
            "aria-label": _ctx.$t('translatorCard.address'),
            alt: _ctx.$t('translatorCard.pointerIconAlt')
          }, null, 8, _hoisted_23),
          _createElementVNode("p", {
            "aria-label": _ctx.$t('translatorCard.showOnMap')
          }, _toDisplayString(__props.address), 9, _hoisted_24)
        ])
      ], 2),
      (__props.askForOffer || __props.askMoreButton || __props.phone || __props.email)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              (__props.askMoreButton)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_router_link, {
                      to: {name: _unref(getRouteName)('translatorPage'), params: {nameSlug: __props.nameSlug, tpNumberSlug: __props.tpNumberSlug}},
                      class: "md:mr-5 btn-primary --outlined block md:hidden w-full text-center"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('translatorCard.seeProfile')), 1)
                      ]),
                      _: 1
                    }, 8, ["to"]),
                    _createVNode(ButtonPrimary, {
                      class: "hidden md:block md:mr-5 text-center",
                      name: _ctx.$t('translatorCard.seeProfile'),
                      outlined: "",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (showTranslatorProfileModal.value = !showTranslatorProfileModal.value), ["prevent"]))
                    }, null, 8, ["name"]),
                    _createVNode(_unref(VueFinalModal), {
                      modelValue: showTranslatorProfileModal.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showTranslatorProfileModal).value = $event)),
                      onOpened: openedTranslatorProfileModal,
                      onBeforeClose: closingTranslatorProfileModal,
                      classes: "modal-container",
                      "content-class": "modal-content",
                      "focus-retain": true,
                      "focus-trap": false,
                      "esc-to-close": true
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          class: "modal__close",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (showTranslatorProfileModal.value = false))
                        }, [
                          _createElementVNode("img", {
                            src: _imports_3,
                            alt: _ctx.$t('modal.close'),
                            class: "info-array md:block mr-0 md:mr-12"
                          }, null, 8, _hoisted_27)
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          (openModal.value)
                            ? (_openBlock(), _createBlock(TranslatorPage, {
                                key: 0,
                                "is-modal": true,
                                "name-slug": __props.nameSlug,
                                "tp-number-slug": __props.tpNumberSlug
                              }, null, 8, ["name-slug", "tp-number-slug"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_29, [
              (__props.phone)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
                    href: 'tel:' + __props.phone,
                    class: "flex pr-5 text-light-secondary self-center pb-5 md:pb-0"
                  }, [
                    _createElementVNode("img", {
                      src: _imports_4,
                      "aria-label": _ctx.$t('translatorCard.phone'),
                      alt: _ctx.$t('translatorCard.phoneIconAlt'),
                      class: "pr-2"
                    }, null, 8, _hoisted_31),
                    _createElementVNode("span", _hoisted_32, _toDisplayString(__props.phone), 1)
                  ], 8, _hoisted_30))
                : _createCommentVNode("", true),
              (__props.email)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
                    href: 'mailto:' + __props.email,
                    target: "_blank",
                    class: "flex text-light-secondary self-center pb-5 md:pb-0"
                  }, [
                    _createElementVNode("img", {
                      src: _imports_5,
                      "aria-label": _ctx.$t('translatorCard.mail'),
                      alt: _ctx.$t('translatorCard.mailIconAlt'),
                      class: "pr-2"
                    }, null, 8, _hoisted_34),
                    _hoisted_35
                  ], 8, _hoisted_33))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 10, _hoisted_1))
}
}

})